var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "side-menu-wrap" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("aside", { staticClass: "side-menu js-side-menu" }, [
      _c("a", { attrs: { href: _vm.header.Url } }, [
        _c("h3", { staticClass: "side-menu-heading" }, [
          _vm._v(_vm._s(_vm.header.Label))
        ])
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { class: _vm.sideMenuClass() },
        _vm._l(_vm.sidebar, function(item, index) {
          return _c("menu-item", { key: index, attrs: { item: item } })
        }),
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn primary-btn js-toggle-side-menu hide-desktop",
        attrs: { type: "button" }
      },
      [_vm._v("Section Menu "), _c("span", { staticClass: "icon-angle-down" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }